/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { INPUT_HEIGHT } from '@/constants';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  onCallback: PropTypes.func,
};

const defaultProps = {
  label: '',
  hideLabel: false,
  onCallback: () => {},
};

const FormOverlay = (props) => {
  const { label, hideLabel, onCallback } = props;
  return (
    <TouchableOpacity
      activeOpacity={1}
      style={[styles.container, { top: !label || hideLabel ? 0 : 30 }]}
      onPress={onCallback}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 10,
    right: 0,
    left: 0,
    zIndex: 2,
    height: INPUT_HEIGHT,
  },
});

FormOverlay.propTypes = propTypes;
FormOverlay.defaultProps = defaultProps;

export default React.memo(FormOverlay, (prev, next) => prev == next);
